import { Wix, logger } from '@wix/photography-client-lib';
import { utils } from '../utils';
var FullscreenHelper = /** @class */ (function () {
    function FullscreenHelper() {
    }
    FullscreenHelper.prototype.init = function (_a) {
        var _this = this;
        var watermarkData = _a.watermarkData;
        this.watermarkData = watermarkData;
        this.compId = Wix.Utils.getCompId();
        this.galleryId = window.galleryId; // TD: move to props
        this.connectedProviders = this.getConnectedProviders();
        this.dateCreated = utils.getDateCreatedTicksFromStr(window.dateCreated);
        Wix.getCurrentPageId(function (pageId) {
            _this.pageId = pageId;
            Wix.Styles.getStyleId(function (styleId) {
                _this.styleId = styleId;
            });
        });
    };
    FullscreenHelper.prototype.getConnectedProviders = function () {
        var connectedProviders = window.connectedProviders;
        try {
            if (!connectedProviders &&
                window.prerenderedGallery &&
                window.prerenderedGallery.gallerySettings) {
                var gallerySettings = window.prerenderedGallery.gallerySettings;
                if (typeof gallerySettings === 'string') {
                    gallerySettings = JSON.parse(utils.stripSlashes(gallerySettings));
                }
                if (gallerySettings &&
                    typeof gallerySettings === 'object' &&
                    gallerySettings.connectedProviders) {
                    connectedProviders = gallerySettings.connectedProviders;
                }
            }
        }
        catch (error) {
            console.error("Error getting connected providers", error);
        }
        return connectedProviders;
    };
    FullscreenHelper.prototype.updateWorkerStyles = function (styles) {
        try {
            var worker = utils.getWorkerWindow();
            worker['pro-gallery-data-' + this.compId].info.styles = styles;
            console.log('Updated worker styles', {
                worker: worker,
                workerData: worker['pro-gallery-data-' + this.compId],
                styles: styles,
            });
        }
        catch (e) {
            console.error('Cannot update worker styles', e);
        }
    };
    FullscreenHelper.prototype.toggleFullscreen = function (item, _a) {
        var styles = _a.styles, totalItemsCount = _a.totalItemsCount, isAccessible = _a.isAccessible;
        // data to be read by the fullscreen iframe
        var worker = utils.getWorkerWindow();
        worker['pro-gallery-data-' + this.compId] = {
            createdAt: Date.now(),
            info: {
                itemIdx: item.idx,
                itemId: item.id,
                compId: this.compId,
                pageId: this.pageId,
                galleryId: this.galleryId,
                styleId: this.styleId,
                styles: styles,
                isAccessible: isAccessible,
                watermarkData: this.watermarkData,
                connectedProviders: this.connectedProviders,
                dateCreated: this.dateCreated,
            },
            items: {
                totalItemsCount: totalItemsCount,
                prerenderedItem: { items: [item] }, // match the vm structure
            },
            window: {
                infiniteScrollUrl: window.infiniteScrollUrl,
                instance: window.instance,
                gallerySettings: utils.getGallerySettingsFromWindow(), // window.gallerySettings,
            },
        };
        // always open the default fullscreen - then read the window date and use replace state to change the url
        // this prevents the iframe from being refreshed
        worker['pro-gallery-fullscreen-comp-id'] = this.compId;
        this.fullscreenOpenedAt = Date.now();
        if (styles.itemClick === 'popup') {
            var baseUrl = 'http://progallery.wixapps.net/fullscreen/';
            var fullscreenState = utils.getFullscreenUrlState(this.compId, item.id, item.idx, this.pageId, this.styleId);
            var fullscreenUrl = baseUrl + fullscreenState;
            Wix.openPopup(fullscreenUrl, '100%', '100%', {
                origin: Wix.WindowOrigin.FIXED,
                placement: Wix.WindowPlacement.CENTER,
            }, this.closeFullscreenCallback, Wix.Theme.BARE);
        }
        else if (styles.itemClick === 'itemUrl') {
            var itemUrl = item.createUrl('full', 'img'); // TODO - use image-client-api to fit to modal dimensions
            var _b = window.screen, width = _b.width, height = _b.height; // TODO - get the site dimensions from Wix SDK
            var margin = 200;
            Wix.openModal(itemUrl, width - margin, height - margin, {
                origin: Wix.WindowOrigin.FIXED,
                placement: Wix.WindowPlacement.CENTER,
            }, this.closeFullscreenCallback, Wix.Theme.BARE);
        }
        else {
            Wix.Utils.navigateToSection({
                sectionId: utils.getFullscreenSectionId(),
                // shouldRefreshIframe: false,
                noTransition: true,
            } /* , utils.getFullscreenUrlState(this.compId, item.id, itemIdx, this.pageId, styleId) */);
        }
        logger.log('expand', {
            selection: 'expand',
        });
    };
    return FullscreenHelper;
}());
var fullscreenHelper = new FullscreenHelper();
export default fullscreenHelper;
//# sourceMappingURL=fullscreenHelper.js.map